/**
 * @flow
 * @format
 */

import React from 'react';
import cc from 'classcat';
import _ from 'lodash';
import { Col } from 'reactstrap';

import Aux from '~/utils/react-aux';
import InputField from '../InputField';
import classes from './StackedGroup.scss';

import fieldWrapperClasses from '../FieldWrapper/FieldWrapper.scss';

type PropsType = {
  calculated: boolean,
  fieldName: string | React$Element<*>,
  tooltip: any,
  value: any,
};

// eslint-disable-next-line react/prefer-stateless-function
export class StackedGroup extends React.Component<PropsType> {
  static defaultProps = {
    value: [],
  };

  props: PropsType; // eslint-disable-line react/sort-comp

  shouldComponentUpdate(nextProps: PropsType) {
    return !_.isEqual(this.props.value, nextProps.value);
  }

  render() {
    const hasTitle = this.props.fieldName;
    const hasFieldNames = _.some(this.props.value, v => v[3]);

    const fieldNames = _.map(
      this.props.value,
      f => (hasTitle ? <h6 key={f[0]}>{f[3]}</h6> : <h5 key={f[0]}>{f[3]}</h5>),
    );

    const rows = this.props.value.map(([id, val, unit]) => (
      <InputField
        key={id}
        className={cc([classes.inputGroup])}
        id={id}
        value={val === null ? 'null' : val}
        readOnly
        unit={unit}
      />
    ));

    if (hasTitle) {
      if (!hasFieldNames) {
        return (
          <Aux>
            <Col
              sm={process.env.REACT_APP_LEFT_PANE_SIZE}
              className={classes.subHeader}
            >
              {this.props.fieldName}
            </Col>
            <Col>
              <div className={fieldWrapperClasses.infoIconWrapper}>
                {this.props.tooltip}
              </div>
              <div className="d-flex">
                <div className={classes.formGroup}>{rows}</div>
              </div>
            </Col>
          </Aux>
        );
      }

      return (
        <Aux>
          <Col sm={12} style={{ paddingBottom: '1rem', display: 'flex' }}>
            {this.props.fieldName}
            {this.props.tooltip}
          </Col>
          <Col
            sm={process.env.REACT_APP_LEFT_PANE_SIZE}
            className={classes.subHeader}
          >
            {fieldNames}
          </Col>
          <Col>
            <div className="d-flex">
              <div className={classes.formGroup}>{rows}</div>
            </div>
          </Col>
        </Aux>
      );
    }

    return (
      <Aux>
        <Col
          sm={process.env.REACT_APP_LEFT_PANE_SIZE}
          className={classes.subHeader}
        >
          {fieldNames}
        </Col>
        <Col>
          <div className={fieldWrapperClasses.infoIconWrapper}>
            {this.props.tooltip}
          </div>
          <div className="d-flex">
            <div className={classes.formGroup}>{rows}</div>
          </div>
        </Col>
      </Aux>
    );
  }
}

export default StackedGroup;



// WEBPACK FOOTER //
// ./src/components/StackedGroup/StackedGroup.js